//阿拉伯文件
module.exports = {
  header1: "الصفحة الأمامية",
  header2: "معلومات عنا",
  header2_1: "من نحن",
  header2_2: "لماذا أخترتنا",
  header3: "منصة التداول",
  header4: "دليل MT5",
  header5: "اتصل بنا",
  header6: "افتح حساب حقيقي",
  header7: "يسجل دخول",
  header8: "تسجيل",
  footer1: "انضم إلى صفوف المتداولين",
  footer2: "تجربة مجانية",
  footer3: "ابدأ التداول الآن",
  footer4: "تابعنا",
  footer5: 'تذييل 5: "حقوق الطبع والنشر" ,',
  footer6: "كل الحقوق محفوظة",
  home1: "منتجات التداول",
  home2: "الإيداع مجانا",
  home3: "أقل من صفر نقطة الاختلاف",
  home4: "تداول في أي مكان",
  home5: 'home5: "أكثر من 200 منتج قابل للتداول" ,',
  home6: "9 خيارات للفترة الزمنية",
  home7: "يمكنك تسجيل الدخول إلى حسابك على الكمبيوتر والجوال",
  home8: "أدوات التحليل المهنية",
  home9: "قم بتنزيل MT5 للكمبيوتر الشخصي",
  home10: "تاجر الشبكة",
  home11: "لا حاجة للتنزيل أو التثبيت",
  home12: "الوصول إلى حسابك على أي متصفح ويب",
  home13: "قوية مثل MT4",
  home14: "اتصل بالسوق لإجراء المعاملات في أي وقت وفي أي مكان",
  home15: "افتح نسخة الويب من mt5",
  home16: "تساعدك على القيام به",
  home17: "أفضل قرار تداول",
  home18: "استخدم أدوات التداول هذه لمساعدتك على اتخاذ القرار الأكثر استنارة",
  home19: "نظام تداول ذكي",
  home20: "احصل على مزايا التداول من خلال المستشار الخبير المحترف",
  home21: "اشارة تداول",
  home22: "أرشدك إلى النجاح كمنارة.",
  home23: "التقويم الاقتصادي",
  home24: "مواكبة أحدث اتجاهات السوق",
  home25: "أداة بروتريدر",
  home26: "احصل على المزيد من فرص التداول",
  home27: "أخبار السوق",
  home28: "وجهات نظر السوق المميزة",
  home29: "رأي المحلل",
  home30: "التقويم الاقتصادي المهني",
  home31: "افتح حساب تداول وقم بإيداع 1,000 دولار أمريكي على الأقل",
  home32: "يمكنك استخدام مجموعة كاملة من أدوات التداول الاحترافية",
  home33: "إيداع الآن",
  home34: "افتح حساب حقيقي",
  home35: "تجربة مثالية",
  home36: "تنفيذ سريع لأوامر التداول",
  home37:
    '"ما هي العناصر الأساسية للمتداولين عند اختيار وسيط تداول العملات الأجنبية؟" - هذا هو السؤال الذي لا نزال نطرحه على أنفسنا عند إنشاء {platform}. نعتقد أن هذه العناصر هي جوهر تحديد قيمنا حتى نتمكن من تلبية احتياجات العملاء والاستمرار في تقديم خدمات ممتازة وموثوقة.',
  home38: "افتح حسابًا في 5 دقائق",
  home39: "مزيج من أكثر من 200 سلعة قابلة للتداول",
  home40: "نظام إدارة حساب كامل الوظائف",
  home41: "سيولة سوقية ممتازة",
  home42: "يتعلم أكثر",
  home43: "الإشراف على الامتثال",
  home44: "توفير أفضل أمان",
  home45:
    "تولي {platform} أهمية كبيرة للإشراف والسلامة. نوفر لجميع العملاء بيئة تداول عملات أجنبية شفافة وآمنة.",
  home46: "مكاتب عالمية",
  home47: "إشراف متعدد الجنسيات",
  home48: "التعاون مع أفضل المؤسسات المالية في العالم",
  home49: "تأمين رأس المال",
  home50: "إشراف",
  home51: "تعويضات",
  home52: "تأمين",
  home53: "طريقة الإيداع",
  home54: "شركاء سيولة السوق",
  home55:
    "{platform} تعاون مع أكثر من 14 من كبار مزودي عروض أسعار السيولة في العالم , ويمكن أن توفر لك السيولة الكافية أفضل عروض أسعار التداول في السوق",
  home56: "معاملات الصرف الأجنبي",
  home57:
    "استفد من الاضطرابات الاقتصادية العالمية للاتصال بأكثر الأسواق المالية سيولة في العالم",
  home58: "ابدأ التداول الآن",
  home59: "تجارة البضائع",
  home59_1: "صفقة كبيرة",
  home60:
    "اختر الذهب أو الفضة أو النفط الخام أو غيرها من السلع اللينة بناءً على دورة تداول السوق الرئيسية",
  home61: "تداول المؤشرات",
  home61_1: "فهرس",
  home62:
    "تداول من خلال تقلبات مؤشرات الأسهم العالمية الكبيرة مثل SP500 و DJ30 و FRA40 و DAX30",
  home63: "تداول الأسهم في الولايات المتحدة / هونغ كونغ",
  home64:
    "تعرف على اتجاهات الشركات العالمية الكبرى وتداول الأسهم الأمريكية وهونج كونج باستخدام العقود مقابل الفروقات",
  home65: "عقد الفرق",
  home66: "الأعمال التجارية العالمية",
  home67: "يشرفنا أن نقدم للعملاء خدمة من الدرجة الأولى والمستقرة",
  home68: "تداول إصدار الويب",
  who0: "Who is {platform}",
  who1: "انضم إلى الوسيط الأكثر إبداعًا",
  who2:
    "تتمتع {platform} بأكثر من 10 سنوات من الخبرة والتجربة في السوق المالية العالمية ، وهي مكرسة لتوفير وصول بسيط وشفاف إلى السوق ومساعدة العملاء على تحقيق أهدافهم المالية.",
  who3:
    '{platform} تأسست في المملكة المتحدة في عام 2010 ، وقد التزمت دائمًا بمفهوم "استمتع بالتداول في أي وقت وفي أي مكان" ، باستخدام خدمات تقنية متقدمة لتزويد العملاء بتجربة تداول ممتازة في سوق الصرف الأجنبي ، بما في ذلك فروق الأسعار الأصلية وحسابات ECN التي تنفذ بدقة المعاملات بسرعة عالية ونظام إدارة قوي للعملاء ، إلخ.',
  who4: "اختر وسيط تداول العملات الأجنبية الموثوق به",
  who5:
    "لقد كان {platform1} ملتزمًا دائمًا بتزويد العملاء ببيئة تداول ممتازة , وقد أصر دائمًا على تجاوز توقعات المنظمين الماليين العالميين. في هذه الصناعة , نتفهم أن المتداولين حريصون على العثور على منصة موثوقة. {platform2 } تحت إشراف العديد من المؤسسات , قمنا بتجميع أكثر من 10000 حساب تداول نشط للعملاء من جميع أنحاء العالم , وكلهم يعتمدون على {platform3} لضمان سلامة أموالهم. ",
  who6: "الوكالة التنظيمية الرئيسية",
  who6_1: "لائحة NFA الأمريكية ، معرف التسجيل: 0542569",
  who7: "العدد العالمي للأشخاص",
  who8:
    "باعتبارها واحدة من الشركات الرائدة في السوق المالية العالمية , توفر {platform} لعملائنا خدمات من الدرجة الأولى والثابتة.",
  who9: "فيما يلي بعض البيانات ذات الصلة بـ {platform}:",
  who10: "10 سنوات +",
  who11: "مؤهلات الصناعة",
  who12: "فوق 1.5 مليار",
  who13: "حجم المعاملات الشهرية",
  who14: "فوق 7 ملايين",
  who15: "حساب العميل",
  who16: "1.5 مليار دولار",
  who17: "حجم المعاملات الشهرية",
  why0: "لماذا تختار {platform}",
  why1: "ليست مجرد منصة , بل شريك",
  why2:
    " ماذا يريد المتداولون عند اختيار وسيط تداول العملات الأجنبية؟ '- هذه هي الأسئلة التي ظللنا نطرحها على أنفسنا عندما أسسنا {platform}. أعتقد أن هذه العناصر هي الجوهر الذي يحدد قيمنا , حتى نتمكن من تلبية احتياجات عملائنا والاستمرار في تقديم خدمات ممتازة وموثوقة.' و",
  why3:
    "أهم شيء هو أننا نريد بناء علامة تجارية معروفة جيدًا تتجاوز السعر أو المنتج. نريد أن نصبح علامة تجارية يتم تداولها في الجيل الجديد. تتيح لنا معرفة احتياجات عملائنا إجراء تغييرات بمرونة أكبر. نحن علامة تجارية جديدة عالية الأداء. منصة تداول الجيل , {platform} دائمًا بجانبك عندما تحتاجها. ",
  why4: "نحن بجانبك خلال رحلة التداول",
  why5:
    "سواء كنت مبتدئًا أو خبيرًا في التداول لسنوات عديدة , سيقدم لك فريقنا الدعم في أي وقت. منصتنا معك في أي وقت وفي أي مكان , ويرافقك فريق خدمة العملاء لدينا في كل خطوة على الطريق , نحن سترافقكم لتنمو معًا. على الرغم من أن منافسينا قد يكونون أقوى منا , إلا أننا نمتلك الدافع للابتكار ودعم منصة تداول متوافقة. تعرف على سبب اختيار {platform} لك: ",
  why6: "افتح حسابًا حقيقيًا فورًا خلال 5 دقائق",
  why7: "رافعة مالية تصل إلى 500: 1",
  why8: "يمكن تداول أكثر من 200 نوع من السلع",
  why9: "توفير مكافأة تداول إضافية",
  why10: "نظام إدارة عملاء قوي",
  why11: "سيولة سوق ممتازة",
  why12: "وكالات تنظيمية متعددة وحسابات منفصلة كضمان",
  Trading1: "استخدام منصة Metatrader5",
  Trading2: "تداول في أي وقت وفي أي مكان",
  Trading3:
    "إذا كنت عميلاً جديدًا لـ {platform} , ما عليك سوى ملء النموذج أعلى هذه الصفحة , ويمكنك استخدام منصة التداول MT5 في غضون بضع دقائق.",
  Trading4:
    "إذا كنت بالفعل أحد عملاء {platform} الذين يتداولون على منصة MT5 , فأنت تحتاج فقط إلى تسجيل الدخول إلى خلفية إدارة العملاء الخاصة بك , والنقر لفتح حسابك وتحديد MetaTrader5 , يمكنك التبديل بسلاسة إلى MT5 وزيادة التحسين خبرتك في التداول. ",
  Trading5:
    "يتيح لك تطبيق MT5 للجوال الاتصال بـ {platform} في أي وقت وفي أي مكان , والاستمتاع بخدمات التداول في جميع الأحوال الجوية.",
  guide0: "دليل MT5",
  guide1: "قم بتنزيل MT5 على جهاز الكمبيوتر الخاص بك",
  guide3: "كيفية إدراج حصة الرسم البياني؟",
  guide3_0: "اتبع الخطوات التالية:",
  guide3_1: "1) في عمود القائمة العلوي , حدد إدراج حصة.",
  guide3_2: "2) يمكنك أيضًا إدراج حصة من قسم التنقل.",
  guide4: "كيف يتم التحايل على حماية جدار الحماية؟",
  guide4_1:
    "امنع جدار الحماية المضاد للفيروسات الخاص بك من التقدم بطلب للحصول على MetaTrader 4 وفتح منفذ 1950. للتقدم بطلب للحصول على MetaTrader 5 , افتح المنفذ 443.",
  guide5: "كيف أقوم بإنشاء خطوط الاتجاه وخطوط البحث الأخرى؟",
  guide5_1: "1) في عمود القائمة العلوي , حدد‘ إدراج ",
  guide5_2: "2) حدد خط الاتجاه المطلوب.",
  guide5_3:
    "3) بعد تحرير زر الماوس , ستظهر أيقونة صورة لخط الاتجاه المحدد مع علامة متصالبة. استخدم الماوس لوضع علامة التقاطع على المخطط المحدد. انقر بالماوس مع الاستمرار لتحريكه استخدم الماوس للضبط حجم خط الاتجاه. ",
  guide5_4:
    "يمكن أيضًا الوصول إلى اختصار البحث الخطي سريعًا بالنقر فوق بحث خط شريط الأدوات' استعراض ', بحيث يظهر الرمز أسفل قائمة الوظائف.",
  guide5_5:
    "يمكنك أيضًا اختيار الخيارات الأخرى التي تظهر أعلى الشاشة. بما في ذلك النقر على خطوط الاتجاه , والتقاطع , وتراجعات فيبوناتشي , وما إلى ذلك",
  guide6: "كيف يتم عرض الرسم البياني الشريطي؟",
  guide6_1:
    "في شريط القائمة في الأعلى , حدد' Chart Bar Graph 'أو استخدم اختصار لوحة المفاتيح (Alt + 1)",
  guide7: "كيف تحصل على معلومات الحساب والمعاملات اليومية على منصة ميتاتريدر؟",
  guide7_1:
    "يرجى استخدام جزء المحطة الطرفية (TERMINAL) من النظام الأساسي. إذا لم تفتح هذا الجزء , يمكنك تصفح المحطة الطرفية أو استخدام اختصار لوحة المفاتيح Cntrl + t.",
  guide7_2: "في قسم Terminal , حدد' Account History Tag '.",
  guide7_3:
    "تظهر لك هذه العلامة محفوظات حسابك. ويمكن أيضًا طباعتها من أجل راحتك.",
  guide7_4: "انقر على زر الفأرة الأيمن في أي مكان في هذا القسم.",
  guide7_5:
    "حدد' حفظ كتقرير '(يمكن أيضًا حفظه كملف HTML , والذي يمكن تحويله إلى ملف Excel للتسجيل.)",
  guide8: "كيفية عرض مخطط الشموع اليابانية؟",
  guide8_1:
    "في شريط القائمة العلوي ، حدد' Chart Candlestick 'أو استخدم اختصار لوحة المفاتيح (Alt + 2).",
  guide9_0:
    "هل يمكنني استخدام واجهة تطبيق MetaTrader على نظامك؟ هل يمكن القيام بذلك على الحساب المصغر / التناظري أولاً؟",
  guide9_1:
    "نعم ، طالما أردت ، يمكنك استخدام الحساب التناظري أولاً. بشكل عام ، تنطبق شروط وأحكام محددة على واجهة التطبيق للوصول الحقيقي إلى النظام. يرجى التأكد من مناقشة مشروعك مع ممثل شركة FXDD ، بحيث ، يمكنهم مساعدتك. ",
  guide10: "كيفية عرض الرسم البياني الخطي؟",
  guide10_1:
    "في شريط القائمة العلوي ، حدد' رسم بياني لخط الرسم البياني 'أو استخدم اختصار لوحة المفاتيح (Alt + 3).",
  guide11: "كيفية تكبير الرسم البياني أو تصغيره؟",
  guide11_1: "1) تأكد من تمكين شريط أدوات' المخطط ",
  guide11_2:
    "2) بعد ذلك ، حدد رمز الإجراء المعقول الموجود ضمن قائمة الوظائف , أي" +
    "و" -
    ".",
  guide11_3: "3) حدد أحد الرمزين للتكبير أو التصغير.",
  guide11_4:
    "أو استخدم اختصار لوحة المفاتيح لهذه الوظيفة. التكبير هو (Shift +) ، والتصغير (-).",
  guide12: "هل تساعد منصة MetaTrader تداول اللوت الصغير (10 آلاف)؟",
  guide12_1:
    "نعم ، يمكنك استخدام منصة MetaTrader لتداول العقود المصغرة (10 آلاف).",
  guide12_2: "فيما يلي مجموعة أحجام اللوت التي نستخدمها للتداول على ميتاتريدر:",
  guide12_3:
    '0.01 لوت = 1000 عملة أساسية للمنظمة (أو دولار أمريكي) لوتنا "المصغر السوبر".',
  guide12_4:
    '0.10 عقد = 10000 عقد "صغير" خاصتنا بالعملة الأساسية للمؤسسة (أو الدولار الأمريكي).',
  guide12_5:
    '1.00 لوت = 100000 لوتنا "القياسي" بالعملة الأساسية للمؤسسة (أو الدولار الأمريكي).',
  guide13: "لقد قمت بتنزيل المنصة. كيف أسجل الدخول إلى حسابي الحقيقي للتداول؟",
  guide13_1:
    'يجب أن يكون المستخدم قد تلقى إشعارًا بالبريد الإلكتروني بالموافقة على الحساب ، يشير إلى اسم تسجيل الدخول وكلمة المرور (على سبيل المثال ، اسم تسجيل الدخول هو "81234" وكلمة المرور "xxxxx"). هذه هي معلومات الحساب الخاصة بحسابك الحقيقي. إذا قمت بتنزيل النظام الأساسي ، فافتح شاشة تسجيل الدخول. لاحظ أن الشاشة التي تفتح في هذا الوقت ستطلب منك فتح حساب. يمكنك النقر فوق "X" للخروج من هذه الشاشة.',
  guide13_2:
    'عند تسجيل الدخول ، حدد "ملف تسجيل الدخول" واكتب اسم تسجيل الدخول وكلمة المرور.',
  guide13_3:
    'يحتوي حقل الخادم على قائمة منسدلة ، حدد الخادم التالي: "FXDD-MT5 Live Server 2-FXDD".',
  guide13_4:
    'انتبه إلى صوت "ding" (نغمة التأكيد) ، سيظهر حسابك في الزاوية اليسرى العليا من المنصة.',
  guide13_5:
    "إذا رأيت تحرك السعر في Market Watch وعرض الجزء الطرفي الرصيد الصحيح ، فهذا يعني أنك قمت بتسجيل الدخول بنجاح إلى حسابك الحقيقي. إذا كنت تواجه مشكلة في تسجيل الدخول ، فيرجى إرسال بريد إلكتروني إلى support@leedword.com.",
  guide14: "كيف يمكنني تغيير كلمة المرور الخاصة بي على MetaTrader؟",
  guide14_1:
    'في شريط القائمة العلوي ، حدد "خيارات الأداة" أو اختصار لوحة المفاتيح (Ctrl + O).',
  guide14_2: 'ضمن رمز "الخادم" ، حدد "تعديل".',
  guide14_3: 'أدخل كلمة المرور الحالية في حقل النص "كلمة المرور الحالية".',
  guide14_4: 'ضع علامة على "تعديل كلمة المرور الرئيسية".',
  guide14_5: 'أدخل كلمة المرور الجديدة في حقل النص "كلمة المرور الجديدة".',
  guide14_6: 'أعد كتابة كلمة المرور الجديدة في الحقل النصي الثاني "تأكيد".',
  guide15: "كيف تختار لغة؟",
  guide15_1:
    'في شريط القائمة العلوي ، حدد "تصفح اللغة" واختر لغتك المفضلة. ثم أغلق المنصة وأعد تشغيل البرنامج.',
  guide16:
    "ما هي اختصارات لوحة المفاتيح التي يمكن استخدامها لعرض النوافذ المختلفة على النظام الأساسي؟",
  guide16_1: "أكثر اختصارات لوحة المفاتيح شيوعًا هي:",
  guide16_2: "Ctrl + M = نافذة مراقبة أسعار السوق",
  guide16_3: "Ctrl + N = نافذة التنقل",
  guide16_4: "Ctrl + T = نافذة طرفية",
  guide17: "كيف يمكنني عرض جميع أزواج العملات التي تقدمها أف أكس دي دي؟",
  guide17_1:
    'في نافذة Market Watch ، انقر بزر الماوس الأيمن واختر "Show All" لعرض جميع أزواج العملات التي يمكن تداولها. تظهر جميع أزواج العملات على الفور.',
  guide18: "كيف أعرض أسعارًا مرتفعة / منخفضة في نافذة Market Watch؟",
  guide18_1:
    "في نافذة Market Watch ، اتبع الخطوات أدناه لعرض الأسعار المرتفعة / المنخفضة:",
  guide18_2: "انقر بزر الماوس الأيمن (أي جزء) في نافذة Market Watch",
  guide18_3:
    'حدد "مرتفع" / "منخفض". (في هذا الوقت ، ستظهر الأسعار المرتفعة والمنخفضة لكل زوج عملات في اليوم.)',
  guide19: "هل يمكنك توجيه عملية إنشاء الرسوم البيانية؟ ما هي الخيارات؟",
  guide19_1:
    "نعم ، تعد منصة MetaTrader 5 واحدة من أكثر المنصات تقدمًا في السوق ، وخاصة خيارات وحزم الرسومات.",
  guide19_2:
    'استخدم خيار "مواضيع المساعدة" ضمن قائمة المساعدة (اضغط F1) وحدد قسم "بدء العمل مع الرسم البياني". يجب أن يكون هذا الجزء بداية بداية جيدة.',
  guide19_3:
    'يمكنك تغيير المظهر العام للرسم البياني ("قائمة الوظائف" - "الرسم البياني" - "المحتوى"). يمكنك تغيير لون الخلفية والمقدمة والجدول وما إلى ذلك. يمكنك التمرير إلى حافة نافذة المخطط لضبط حجم المخطط ، وسحب زر الماوس لضبط الحجم.',
  guide20: "كيفية تعديل الفترة الزمنية لعرض الرسوم البيانية للميتاتريدر؟",
  guide20_1:
    'عند إضافة حد زمني إلى شريط القائمة الرئيسية ، حدد "تصفح شريط الأدوات". "فترة" (إذا لزم الأمر). استخدم وسيلة الإيضاح التالية لاستخدام الحد الزمني في الرسم البياني:',
  guide20_2: "M1 = مخطط دقيقة واحدة",
  guide20_3: "M5 = مخطط 5 دقائق",
  guide20_4: "M15 = مخطط 15 دقيقة",
  guide20_5: "M30 = مخطط 30 دقيقة",
  guide20_6: "H1 = مخطط ساعة واحدة",
  guide20_7: "H4 = مخطط 4 ساعات",
  guide20_8: "D1 = مخطط يومي",
  guide20_9: "W1 = مخطط أسبوعي",
  guide20_10: "MN = الرسم البياني الشهري",
  guide21: "هل يوجد دليل مستخدم للميتاتريدر 5؟",
  guide21_1:
    'نعم ، حدد "مواضيع المساعدة" على المنصة أو يمكنك النقر هنا للتنزيل. يرجى ملاحظة أن لدينا ندوة عبر الإنترنت لمساعدتك على فهم وظائف هذه المنصة. إذا كنت ترغب في المشاركة في هذه الندوات عبر الإنترنت ، يرجى إرسال بريد إلكتروني إلى قسم المبيعات.',
  guide22: "ما هي المنطقة الزمنية على منصة ميتاتريدر؟ هل يمكن تعديل هذا الوقت؟",
  guide22_1:
    "خلال التوقيت الصيفي ، يكون وقت العميل على MetaTrader هو GMT + 3 (توقيت غرينتش بالإضافة إلى 3 ساعات ، بتوقيت بكين بالإضافة إلى 5 ساعات). لسوء الحظ ، لا يمكن تغيير الوقت على منصة MetaTrader. نحن نأسف بشدة لأي إزعاج.",
  guide23: "كيف تفتح حساب تناظري آخر على منصة MetaTrader؟",
  guide23_1: 'حدد "ملف لفتح حساب" في المنصة',
  guide23_2:
    'املأ المعلومات المطلوبة (تأكد من تحديد العمود "أوافق على الاشتراك في رسالتك الإخبارية")',
  guide23_3: 'حدد "التالي" (في صفحة الخادم)',
  guide23_4: 'اختر "التالي" (يرجى ملاحظة أن اسم المستخدم وكلمة المرور سيظهران)',
  guide23_5: 'حدد "إنهاء"',
  guide23_6:
    "سيسمح لك هذا البرنامج بتسجيل الدخول تلقائيًا إلى حسابك التمثيلي الجديد وعرضه في نافذة التنقل.",
  guide24: "ما هي العوامل التي تؤثر على مقدار التواصل في البرنامج؟",
  guide24_1:
    "يعتمد مقدار اتصال الإخراج على نشاط المستخدم ، والمقدار صغير جدًا. يعتمد مقدار الاتصال الذي تم إدخاله بشكل مباشر على عدد نوافذ الرسم البياني المفتوحة.",
  guide25: "هل يمكنني تلقي التحذيرات عبر البريد الإلكتروني؟",
  guide25_1:
    "اتبع الخطوات أدناه لإنشاء تنبيه بالبريد الإلكتروني في MetaTrader 5:",
  guide25_2:
    'تختلف كافة إعدادات بروتوكول نقل البريد البسيط (SMTP) باختلاف مزود خدمة الإنترنت. إذا تلقيت رسالة خطأ ، فاتصل بالدعم الفني لمزود خدمة الإنترنت واطلب منه تعيين بروتوكول تسليم البريد البسيط. إذا كنت تستخدم Outlook ، فيمكنك تحديد "إلغاء عند تعديل حساب البريد الإلكتروني للأداة في الخطوة التالية" لتعيين بروتوكول نقل البريد البسيط.',
  guide25_3: 'حدد "خيارات الأداة".',
  guide25_4: 'حدد رمز "البريد الإلكتروني".',
  guide25_5:
    "قم بتحرير الإعدادات أعلاه وفقًا لمتطلبات مزود خدمة الإنترنت الخاص بك. عادةً ما يكون النص الأحمر الفاتح هو القاعدة العامة التي يجب عليك تسجيل الدخول إليها. للحصول على إرشادات محددة ، يرجى الاتصال بمزود خدمة الإنترنت الخاص بك. (ملاحظة: تشمل خدمات البريد الإلكتروني عبر الإنترنت التي لا يمكن استخدامها Hotmail و Yahoo و Gmail وما إلى ذلك)",
  guide25_6:
    "خادم بروتوكول نقل البريد البسيط - هذا هو عنوان خادم البريد لمزود خدمة الإنترنت الخاص بك",
  contact1: "عندما تحتاج إلينا ، فنحن دائمًا بجانبك",
  contact2:
    "إذا كانت لديك أي أسئلة أو كنت بحاجة إلى مزيد من المساعدة , فيرجى الاتصال بنا من خلال طرق الاتصال التالية. وسنبذل قصارى جهدنا للإجابة على جميع الأسئلة في أقرب وقت ممكن.",
  contact3: "مقر أستراليا",
  contact4: "مكتب كايمان",
  contact5: "مكتب تايبيه",
  contact6: "رقم 7 ، القسم 5 ، منطقة Xinyi ، تايبيه ، تايوان (تايبيه 101)",
  contact7: "عنوان البريد الإلكتروني",
  contact8: "هاتف",
  address1_0: "أستراليا ، سيدني",
  address2_0: "تايبيه",
  address3_0: "تايلاند ، بانكوك",
  address4_0: "ماليزيا ، كوالالمبور",
  address5_0: "United Kingdom، London",
  address6_0: "الولايات المتحدة ، نيويورك",
  address7_0: "سنغافورة ، مدينة سنغافورة",
  address8_0: "جزر كايمان ، جورج تاون",
  address9_0: "قبرص ، نيقوسيا",
  address10_0: "هونغ كونغ",
  address11_0: "فيتنام ، هانوي",
  address12_0: "أستراليا ، ملبورن"
};



// WEBPACK FOOTER //
// ./src/common/lang/ar.js